var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-order-item"
  }, [_c('div', {
    staticClass: "s-order-item-image",
    class: _vm.order.is_original_org ? 's-bg-secondary' : 's-bg-warning'
  }, [_c('div', {
    staticClass: "s-order-item-image-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]), _c('p', {
    staticClass: "s-py-2 s-text-center"
  }, [_vm.order.is_original_org ? _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/group-buying/poya.svg")
    }
  }) : _c('img', {
    attrs: {
      "src": require("@/assets/images/liff/group-buying/poya-home.svg")
    }
  })])]), _c('div', {
    staticClass: "s-order-item-info s-space-y-2"
  }, [_c('p', {
    staticClass: "s-text-gray-darker s-font-semibold"
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('p', {
    staticClass: "s-font-bold"
  }, [_c('span', {
    staticClass: "s-text-gray-darker s-mr-3"
  }, [_vm._v(_vm._s(_vm.order.quantity) + " 組")]), _c('span', {
    staticClass: "s-text-secondary"
  }, [_vm._v(_vm._s(_vm.$currency(_vm.data.total_price)))])]), _c('p', {
    staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
  }, [_vm._v("訂單編號 "), _vm.order.order ? _c('span', [_vm._v(_vm._s(_vm.order.order.outer_order_number))]) : _vm._e()]), _c('p', {
    staticClass: "s-text-gray s-text-xs"
  }, [_vm._v(_vm._s(_vm.order.groupbuying.group.name))])]), _c('div', {
    staticClass: "s-order-item-tag"
  }, [_vm.shouldShowTag ? _c('span', {
    staticClass: "s-tag s-tag-secondary s-mb-auto"
  }, [_vm._v(_vm._s(_vm.order.status_label))]) : _vm._e(), _vm.returnLabel ? _c('a', {
    staticClass: "s-link s-link-secondary s-mt-auto",
    attrs: {
      "href": _vm.returnURL
    }
  }, [_vm._v(_vm._s(_vm.returnLabel))]) : _vm._e()]), _vm.invoice ? _c('Modal', {
    ref: "modal",
    attrs: {
      "title": "發票明細",
      "no-actions": ""
    }
  }, [_c('ul', {
    staticClass: "s-text-gray-darker s-text-sm s-space-y-3"
  }, [_c('li', [_vm._v("發票號碼：" + _vm._s(_vm.invoice.invoice_number))]), _c('li', [_vm._v("發票日期：" + _vm._s(_vm.invoiceDateTime.format('YYYY/MM/DD')))]), _c('li', [_vm._v("發票時間：" + _vm._s(_vm.invoiceDateTime.format('HH:mm:ss')))]), _c('li', [_vm._v("發票總金額：" + _vm._s(_vm.$currency(_vm.invoice.total_price)))])])]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }